module.exports = __webpack_public_path__ + "img/mac.995b1e76.svg";